import * as React from "react";

import styled, { css } from "styled-components";
import {
  FilePickerContent,
  IFilePickerContentProps,
} from "./Content.component";
import { FilePickerInput } from "./Input.component";
import { observer } from "mobx-react-lite";

const WrapperEl = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 258px;
  justify-content: center;
  position: relative;
  width: 100%;
  ${(props) =>
    props &&
    css`
      background: ${props.theme.colors.background.filePicker};
      border-radius: ${props.theme.dimension.spacing.xs}px;
      border: 1px dashed ${props.theme.colors.borders.filePicker};
    `}
`;

export type IFilePickerContainerProps = IFilePickerContentProps;

export const FilePickerContainer: React.FC<IFilePickerContainerProps> = observer(
  (props) => {
    return (
      <WrapperEl>
        <FilePickerInput />
        <FilePickerContent {...props} />
      </WrapperEl>
    );
  }
);
